import service, {
  IVendor,
  IVendorId,
} from '@/services/vendor';
import { IPage } from '@/services/gql/generic-find';
import { debounceSearch, promiseError } from '@/store/utils';
import { IStateVendors } from './types';

export default () => ({
  namespaced: true,
  state: () => ({
    list: [],
    loadSeeds: [],
    page: {
      number: 1,
      query: {},
      recordCount: 0,
      size: 10,
    },
  } as IStateVendors),
  getters: {
    isSearchLoading: (state: IStateVendors) => !!state.loadSeeds.length,
  },
  mutations: {
    LOAD(state: IStateVendors, data: IVendor[] = []) {
      state.list = data;
    },
    LOAD_SEED_ADD(state: IStateVendors, seed: number) {
      state.loadSeeds = state.loadSeeds.concat(seed);
    },
    LOAD_SEED_CLEAR(state: IStateVendors) {
      state.loadSeeds = [];
    },
    LOAD_SEED_REMOVE(state: IStateVendors, seed: number) {
      state.loadSeeds = state.loadSeeds.filter(loadSeed => loadSeed !== seed);
    },
    REMOVE(state: IStateVendors, id: IVendorId) {
      // reduce record count by 1
      state.page.recordCount = state.page.recordCount - 1;

      // remove item from list
      state.list = state.list.filter((item: IVendor) => (
        item.id !== id
      ));
    },
    UPDATE_PAGE(state: IStateVendors, payload: any) {
      state.page = {
        ...state.page,
        ...payload,
      };
    },
  },
  actions: {
    load: ({ commit, state }: any, page: IPage) => (
      debounceSearch({
        commit,
        page,
        service,
        state,
        onSearch: (pageParams: any) => (
          service.find(`id, name`, {
            ...pageParams,
            where: state.page.query,
          })
        ),
      })
    ),
    remove: ({ commit }: any, id: IVendorId) => (
      service
        .remove(id)
        .then(() => commit('REMOVE', id))
        .catch(promiseError('VENDORS_REMOVE', commit))
    ),
  },
});
